import type {ReactElement} from 'react';
import React from 'react';
import type {ThumbnailItemProps} from '@Components/thumbnail-item';
import {ThumbnailItem} from '@Components/thumbnail-item';
import styles from './contextual-menu-thumbnail-item.module.scss';

interface ContextualMenuThumbnailItemProps extends ThumbnailItemProps {
  isMultiLineText?: boolean;
  hasCustomMargin?: boolean;
  hasCustomDimensions?: boolean;
}

export function ContextualMenuThumbnailItem({
  isMultiLineText = false,
  hasCustomMargin = false,
  hasCustomDimensions = false,
  ...props
}: ContextualMenuThumbnailItemProps): ReactElement<any> | null {
  const getThumbnailClasses = (): string => {
    const classes = [styles.item];
    if (isMultiLineText) {
      classes.push(styles.multiLineText);
    }
    if (!hasCustomDimensions) {
      classes.push(styles.dimensions);
    }
    if (!hasCustomMargin) {
      classes.push(styles.margin);
    }

    return classes.join(' ');
  };

  return <ThumbnailItem {...props} className={`${props.className ?? ''} ${getThumbnailClasses()}`} />;
}
